import { singleton } from 'tsyringe'
import type { GMOGateway } from '@/interface/gateway'

interface CardObject {
  cardno: string;
  expire: string;
  securitycode?: string;
  holdername?: string;
  tokennumber?: 1
}

interface TokenObject {
  token: string
  toBeExpiredAt: string
  maskedCardNo: string
  isSecurityCodeSet: boolean
}

declare var Multipayment: {
  init: (apiKey: string) => void
  getToken: (cardObject: CardObject, callback: (params: { resultCode: string, tokenObject: TokenObject }) => void) => void
}

@singleton()
export class GMOGatewayImpl implements GMOGateway {
  private _client: typeof Multipayment | undefined

  constructor(private apiKey: string) {}

  get client() {
    if (this._client) return this._client

    if (!Multipayment) return null
    Multipayment.init(this.apiKey)
    this._client = Multipayment

    return this._client
  }

  async getToken(data: CardObject): Promise<{
    token: string
    toBeExpiredAt: string
    maskedCardNo: string
  }> {
    const { client } = this
    if (!client) throw new Error('Multipayment client not found')

    return new Promise((resolve, reject) => {
      Multipayment.getToken(data, ({ resultCode, tokenObject }) => {
        const { token, toBeExpiredAt, maskedCardNo } = tokenObject

        resolve({
          token,
          toBeExpiredAt,
          maskedCardNo
        })
      })
    })
  }
}
